import { makeComponent } from '../core';
import React from 'react';

export const ButtonGroup = makeComponent( class extends React.Component<{}>{
    render(){
        return (<>{this.props.children}</>);
    }
});